import { createFileRoute } from '@tanstack/react-router';
import { useSuspenseQuery } from '@tanstack/react-query';
import { organizationQueries } from '@/features/organizations/queries';
import { SupplyPointsTab } from '@/features/organizations/components/supply-points-tab/SupplyPointsTab';
import { OrgTabListSkeleton } from '@/common/components/loading-skeleton/OrgTabListSkeleton';

export const Route = createFileRoute('/_authenticated/organizations/$organizationId/supply-points')(
  {
    component: RouteComponent,
    pendingComponent: OrgTabListSkeleton,
  }
);

function RouteComponent() {
  const { organizationId } = Route.useParams();
  const { data: org } = useSuspenseQuery(organizationQueries.detail(organizationId));
  if (!org) return null;
  return <SupplyPointsTab org={org} />;
}
